/**
 * Утилиты для оборачивания ссылок Booking.com в партнёрский редирект Travelpayouts.
 * Формат: https://tp.media/r?marker=<marker>&p=<programId>&u=<encoded original>&sub_id=<optional>
 */

import { shouldSkipUrl } from './trip';
import { wrapAffiliateLink } from '../proxy';

const BOOKING_HOSTS = new Set([
    'www.booking.com',
    'booking.com'
]);

export const DEFAULT_BOOKING_AFFILIATE_PARAMS = {
    marker: '633678',
    programId: '2076'
};

export function isBookingUrl(href) {
    if (!href || typeof href !== 'string') return false;
    try {
        const url = new URL(href);
        return BOOKING_HOSTS.has(url.hostname.toLowerCase());
    } catch {
        return false;
    }
}

/**
 * Оборачивает обычный Booking.com URL в партнёрский redirect через Travelpayouts.
 * Используется для ссылок в блоге.
 */
export function decorateBookingUrl(href, config = {}, _language = null) {
    if (!href || typeof href !== 'string') return href;

    // Пропускаем, если это уже партнёрский redirect или другой агрегатор
    if (shouldSkipUrl(href)) return href;

    if (!isBookingUrl(href)) return href;

    const marker = config.marker || DEFAULT_BOOKING_AFFILIATE_PARAMS.marker;
    const programId = config.programId || DEFAULT_BOOKING_AFFILIATE_PARAMS.programId;
    const subId = config.subId;

    // Travelpayouts кодирует только целевой URL (u)
    const encodedTarget = encodeURIComponent(href);
    let finalUrl = `https://tp.media/r?marker=${encodeURIComponent(marker)}&p=${encodeURIComponent(programId)}&u=${encodedTarget}`;

    if (subId) {
        finalUrl += `&sub_id=${encodeURIComponent(subId)}`;
    }

    // language сейчас не требуется Booking redirect, оставляем на будущее
    return wrapAffiliateLink(finalUrl);
}


